// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__nMJXk","calendarButtons":"ClockData_calendarButtons__2cj8H"};